module.exports = __webpack_public_path__ + "static/media/create_sections_requests_and_section_counts.7e310093.mov";